/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Recording_Denied_TitleInputs */



/**
* | output |
* | --- |
* | "The notetaker was not allowed to record" |
*
* @param {Meeting_Notetaker_Issue_Recording_Denied_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_recording_denied_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Recording_Denied_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Recording_Denied_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De notetaker mocht niet opnemen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le notetaker n'a pas pu enregistrer")
	return /** @type {LocalizedString} */ ("The notetaker was not allowed to record")
});